import { getDaysInMonth } from "./time";

export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getDaysInMonthWithoutSunday = (month, year) => {
  const date = new Date(month, year);
  const days: number[] = [];
  while (date.getMonth() === month) {
    // Exclude weekends
    const tmpDate = new Date(date);
    const weekDay = tmpDate.getDay(); // week day
    const day = tmpDate.getDate(); // day

    if (weekDay % 6) {
      // exclude 0=Sunday and 6=Saturday
      days.push(day);
    }

    date.setDate(date.getDate() + 1);
  }
  return days;
};

export const getDaysSinceDate = (lastRecdDate) => {
  if (!lastRecdDate) return null; // no sent date available

  const sentDate = new Date(lastRecdDate);
  const today = new Date();

  // normalize times so difference is only in days
  const diffTime = today.setHours(0, 0, 0, 0) - sentDate.setHours(0, 0, 0, 0);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const getPastMonthYear = () => {
  const date = new Date();
  const currMonth = date.getMonth();
  const currYear = date.getFullYear();

  if (currMonth === 0) {
    return { month: 11, year: currYear - 1 };
  } else {
    return { month: currMonth - 1, year: currYear };
  }
};

export const addAbsentDays = (attdObj, month, year, emp_id, emp_name) => {
  const numOfDays = getDaysInMonth(month, year);
  // Loop for number of days
  for (let i = 0; i < numOfDays; i++) {
    const currentDate = new Date(year, month, i + 1).getDate();
    const attdDate = new Date(attdObj[i]?.curr_date).getDate();

    //checks if current date exists in attendance

    if (attdObj[i] === undefined || currentDate !== attdDate) {
      //Enters absent value
      const newDate = new Date(year, month, i + 2);
      attdObj.splice(i, 0, {
        curr_date: newDate,
        emp_code: String(emp_id),
        emp_name: emp_name,
        in_time: "",
        out_time: "",
        working_hrs: "",
      });
    }
  }
  return attdObj;
};

export const formatTimestamp = (iso: string) =>
  new Date(iso).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
